export const loginError = {
  icon: "/img/oops_icon.png",
  heading: "No Account",
  showContact: true,
  showClose: true,
  pagePreserve: true,
  text: "We couldn’t find an account with that email address.",
  buttonText: "Create Account"
}
export const accountExists = {
  icon: "/img/exist_icon.svg",
  heading: "Account Already Exists",
  showContact: false,
  showClose: true,
  pagePreserve: true,
  showForgotPassword: true,
  text: "It looks like an account already exists with this email address. Please login.",
  buttonText: "Login"
}
export const welcomeSignup = {
  icon: "/img/yellow-logo.svg",
  heading: "",
  showContact: false,
  showClose: false,
  showForgotPassword: false,
  welcomeSignup: true,
  text: "On the following screens weʼll ask you to register the Cozys in your home & adjust your temperature settings. Youʼll need the following information:",
  buttonText: "Let's Get Cozy!"
}
export const barcodeError = {
  icon: "/img/oops_icon.png",
  heading: "Oops!",
  showContact: true,
  showClose: true,
  text: "We could not identify a Cozy with this label. Please check the 8-digit barcode again.",
  buttonText: "Try Again"
}
export const barcodeInfo = {
  icon: "/img/scan_bg@3x.svg",
  mainImage: "/img/scan_bg@3x.svg",
  barcodeInfo: true
}
export const barcodeSucceed = {
  icon: "/img/congrats_img@3x.svg",
  heading: "Congrats!",
  showContact: false,
  showClose: false,
  text: "We’ve identified your home! On the next page we’ve recommended temperature settings that you can edit to make sure you’re nice and Cozy.",
  buttonText: "Edit Settings"
}
export const setTemperature = {
  icon: "/img/noun_icon.png",
  heading: "Temperature Schedule",
  showContact: true,
  showClose: false,
  text: "We're saving this schedule for all of your rooms with Cozys. You can edit individual room schedules in the home screen.",
  buttonText: "Take Me Home!"
}
export const copyTemperatureSchedule = {
  icon: "/img/congrats_img@3x.svg",
  heading: "Success!",
  showContact: false,
  showClose: false,
  text: "The settings have been saved. You can edit individual room schedules in the home screen.",
  subText: "Note: Your target temperature setting and the actual room temperature may be different due to window leaks, cold radiators, or other building conditions. If you're uncomfirtable send us a message!",
  buttonText: "Got it!"
}
export const note = {
  icon: "/img/noun_icon.png",
  heading: "Note",
  showContact: false,
  showClose: true,
  text: "Your target temperature setting and the actual room temperature may be different due to window leaks, cold radiators, or other building conditions. If youʼre uncomfortable, send us a message!",
  buttonText: "Got it!"
}
export const forgotPassword = {
  icon: "/img/congrats_img@3x.svg",
  heading: "Success!",
  showContact: false,
  showClose: false,
  text: "Please check your email and follow the instructions to reset the password.",
  buttonText: "Got it!"

}
export const resetPassword = {
  icon: "/img/congrats_img@3x.svg",
  heading: "Success!",
  showContact: false,
  showClose: false,
  text: "Your password is successfully updated!",
  buttonText: "Login"
}
export const resetPasswordError = {
  icon: "/img/oops_icon.png",
  heading: "Oops!",
  showContact: true,
  showClose: false,
  text: "Please try again! Token is invalid.",
  buttonText: "Try Again"
}
export const deleteAccount = {
  icon: "/img/trash@3x.png",
  heading: "Delete Account",
  showContact: false,
  showCloseDelete: true,
  text: "This will erase your account information and temperature settings.",
  subText: "Note! This process cannot be undone!",
  buttonText: "Yes, Delete Account"
}
export const scheduleCopied = {
  icon: "/img/congrats_img@3x.svg",
  heading: "Congrats!",
  showContact: false,
  showClose: false,
  text: "Schedule Copied!",
  buttonText: "Got it!"
}
export const commonError = {
  icon: "/img/oops_icon.png",
  heading: "Oops!",
  showContact: false,
  showClose: true,
  text: "Please correct the temperature value. It should be belween 69°F to 86 °F",
  buttonText: "Got it!"
}

export const RoomColors = [
"#8ED04A",
"#5EB793",
"#8F40E2",
"#CC3BCE",
"#CE3B87",
"#2DAB2B"
]

export const Days = [{
  label: "Monday",
  value: 1
}, {
  label: "Tuesday",
  value: 2
}, {
  label: "Wednesday",
  value: 3
}, {
  label: "Thursday",
  value: 4
}, {
  label: "Friday",
  value: 5
}, {
  label: "Saturday",
  value: 6
}, {
  label: "Sunday",
  value: 7
}]

export const weekDaysShort = ['M', 'Tu', 'W', 'Th', 'F', 'Sa', 'Su'] // Short week days

export const Settings = {}
Settings.MinMax = () => {
  return {
    MAX: localStorage.getItem('temperatureType') === 'C' ? 29 : 85,
    MIN: localStorage.getItem('temperatureType') === 'C' ? 10 : 50,
    BLUE: localStorage.getItem('temperatureType') === 'C' ? 21 : 70,
    ORANGE: localStorage.getItem('temperatureType') === 'C' ? 24 : 76,
    RED: localStorage.getItem('temperatureType') === 'C' ? 23 : 75,
    AWAY: localStorage.getItem('temperatureType') === 'C' ? 21 : 69,
    SLEEP: localStorage.getItem('temperatureType') === 'C' ? 21 : 70,
    CELSIUS_ADJUSTMENT_FOR_MAX: 26.7
  }
}

export const defaultSchedule = { home1: '05:30', away: '09:30', home2: '17:30', sleep: '20:30' }

export const customSchedule = [
  { label: 'Home', value: defaultSchedule.home1, valueTo: defaultSchedule.away, temp: Settings.MinMax().RED, src: 'img/home_icon.svg' },
  { label: 'Away', value: defaultSchedule.away, valueTo: defaultSchedule.home2, temp: Settings.MinMax().AWAY, src: 'img/away_icon.svg' },
  { label: 'Home', value: defaultSchedule.home2, valueTo: defaultSchedule.sleep, temp: Settings.MinMax().RED, src: 'img/home_icon.svg' },
  { label: 'Sleep', value: defaultSchedule.sleep, valueTo: defaultSchedule.home1, temp: Settings.MinMax().SLEEP, src: 'img/sleep_icon.svg' }
]

export const editScheduleHeadings = {
  home: {
        helpText: 'Enter the time frame you are awake and at home in the morning.',
        titleImage: 'img/active_home_icon.svg',
        title: 'Home'
      },
  home2: {
        helpText: 'Enter the time frame you are at home in the afternoon/evening.',
        titleImage: 'img/active_home_icon.svg',
        title: 'Home'
      },
  away: {
        helpText: 'Enter the time frame you are away.',
        titleImage: 'img/away_icon_yello.svg',
        title: 'Away'
      },
  sleep: {
        helpText: 'Enter the time you go to sleep.',
        titleImage: 'img/sleep_icon@3x.svg',
        title: 'Sleep'
      }
}

export const celsiusToFahrenheit = (value) => {
  value = parseFloat(value ? value : 0)
  return Math.floor((value * 9) / 5 + 32)
}

export const fahrenheitToCelsius = (value) => {
  value = parseFloat(value ? value : 0)
  return parseFloat(((value - 32) * 5) / 9)
}
// Return user setting for Celcius or Fahrenheit
export const coversion = () => {
  return localStorage.getItem('temperatureType')
}



// WEBPACK FOOTER //
// ./src/constants/common.js